import { message } from 'antd';
import { selectionHasRestrictedPatientSplit } from '../../../selectors/patientSplit';

// Shared entry point for the "Merge" / "Merge & Archive" toolbar actions used by
// the received inbox (ReceivedRecords), the legacy referral page
// (ReferralManagement.legacy), and the new referral-management actions
// (useReferralActions). Those surfaces differ only in their post-merge
// continuation, so this helper owns the common shell:
//   1. the incompatible-record-type guard (all selected rows must share a
//      receiver_type),
//   2. the send-token map, and
//   3. the MERGE_RECORDS_CONFIRM modal payload shape.
//
// `buildOnMerged(tokens)` is called only after the guard passes and receives the
// resolved send tokens; it returns the surface-specific `onMerged` continuation
// the modal runs once the merge succeeds. Each surface keeps its own
// continuation (reload, archive, refresh, soft-block warning) verbatim.
export const openMergeConfirm = ({
  objects,
  openModal,
  archiveAfter = false,
  buildOnMerged,
}) => {
  if (selectionHasRestrictedPatientSplit(objects)) {
    return message.error('This document is restricted by automatic patient separation.');
  }
  const receiverType = objects[0].receiver_type;
  const incompatibleMerge = objects.some((element) => element.receiver_type !== receiverType);
  if (incompatibleMerge) {
    return message.error({ content: 'You can not merge incompatible record types' });
  }

  const tokens = objects.map((x) => x.send_token);
  const data = { tokens, onMerged: buildOnMerged(tokens) };
  if (archiveAfter) data.archiveAfter = true;

  return openModal({ type: 'MERGE_RECORDS_CONFIRM', data });
};

export default openMergeConfirm;
